const environment = 'PRODUCTION';

export const PAGE_LIMIT = 100;

const { API_URL, API_URL_V2, API_URL_V3 } = {
    ["PRODUCTION"]: {
        API_URL: "https://api.push-signals.online/api/",
        API_URL_V2: "https://api2.push-signals.online/api/",
        API_URL_V3: "https://api3.push-signals.online/api/"
    },
    ["DEVELOPMENT"]: {
        API_URL: "http://localhost:8080/api/",
        API_URL_V2: "http://localhost:8083/api/",
        API_URL_V3: "http://localhost:8084/api/"
    }
}[environment];

export { API_URL, API_URL_V2, API_URL_V3 };



// WEBPACK FOOTER //
// ./src/data/config.js